<template>
    <div class="mRetailers-container" v-observe-visibility="startAnimate">
        <div class="mRetailers">
            <div class="mFlex-container">
                <h2 class="mTitle" :class="{animate: animate, onlySafari: isSafari}">Dónde comprar</h2>
                <div class="mRow">
                    <a
                        href="https://www.glup.com/info"
                        @click="retailerClick('Glup') & retailerGA('click', 'retailer :: glup', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="glup" alt="Encuéntrala en la aplicación de GLUP" />
                    </a>
                    <!-- <a
                        href=""
                        @click="retailerClick('Cornershop')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="cornershop" alt="Encuéntrala en la aplicación de Cornershop" />
                    </a> -->
                    <a
                        href="https://articulo.mercadolibre.com.mx/MLM-1815188527-cerveza-sin-alcohol-tecate-00-24-latas-de-355ml-_JM"
                        @click="retailerClick('Mercado Libre') & retailerGA('click', 'retailer :: mercado libre', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="mercado_libre" alt="Encuéntrala en Mercadolibre.com" />
                    </a>
                    <a
                        href="https://nuevo.chedraui.com.mx/cerveza-tecate-sin-alcohol-355ml-3769522/p"
                        @click="retailerClick('Chedraui') & retailerGA('click', 'retailer :: chedraui', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                        id="chedraui"
                    >
                        <img :src="chedraui" alt="Encuéntrala en nuevo.chedraui.com.mx" />
                    </a>
                    <a
                        href="https://www.lacomer.com.mx/lacomer/#!/detarticulo/7503032272436/0/732/1///732?succId=287&succFmt=100"
                        @click="retailerClick('LaComer') & retailerGA('click', 'retailer :: laComer', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="lacomer" alt="Encuéntrala en lacomer.com.mx" />
                    </a>
                    <a
                        href="https://www.heb.com.mx/tecate-cerveza-0-0-lata-355-ml-898460.html"
                        @click="retailerClick('Heb') & retailerGA('click', 'retailer :: heb', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="heb" alt="Encuéntrala en heb.com.mx" />
                    </a>
                </div>
                <div class="mRow-two">  
                    <a
                        href="https://super.walmart.com.mx/ip/bebida-no-alcoholica-tecate-cerveza-clara-0-0-alcohol-355-ml/00750303227243"
                        @click="retailerClick('Walmart') & retailerGA('click', 'retailer :: walmart', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="walmart" alt="Encuéntrala en Walmart.com.mx" />
                    </a>
                    <a
                        href="https://www.amazon.com.mx/stores/page/AC57BA80-80DB-4887-A769-99E9E225DE06?ingress=0&visitId=f5a9b039-de01-4a75-a4ab-18a2d5222d5f"
                        @click="retailerClick('Amazon') & retailerGA('click', 'retailer :: amazon', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="amazon" alt="Encuéntrala en Amazon.com" />
                    </a>
                    <a
                        href="https://www.soriana.com/cerveza-tecate-0.0-lata-355-ml/11688516.html"
                        @click="retailerClick('Soriana') & retailerGA('click', 'retailer :: soriana', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                        id="soriana"
                    >
                        <img :src="soriana" alt="Encuéntrala en soriana.com" />
                    </a>
                </div>
                <div class="mRow-mobile">
                    <a
                        href="https://www.glup.com/info"
                        @click="retailerClick('Glup') & retailerGA('click', 'retailer :: glup', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="glup_mobile" alt="Encuéntrala en la aplicación de GLUP" />
                    </a>
                    <a
                        href="https://articulo.mercadolibre.com.mx/MLM-1815188527-cerveza-sin-alcohol-tecate-00-24-latas-de-355ml-_JM"
                        @click="retailerClick('Mercado Libre') & retailerGA('click', 'retailer :: mercado libre', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="mercado_libre_mobile" alt="Encuéntrala en Mercadolibre.com" />
                    </a>
                </div>
                <div class="mRow-mobile-two">
                    <!-- <a
                        href=""
                        @click="retailerClick('Cornershop')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="cornershop_mobile" alt="Encuéntrala en la aplicación de Cornershop" />
                    </a> -->
                    <a
                        href="https://nuevo.chedraui.com.mx/cerveza-tecate-sin-alcohol-355ml-3769522/p"
                        @click="retailerClick('Chedraui') & retailerGA('click', 'retailer :: chedraui', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="chedraui_mobile" alt="Encuéntrala en nuevo.chedraui.com.mx" />
                    </a>
                    <a
                        href="https://www.lacomer.com.mx/lacomer/#!/detarticulo/7503032272436/0/732/1///732?succId=287&succFmt=100"
                        @click="retailerClick('LaComer') & retailerGA('click', 'retailer :: laComer', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="lacomer_mobile" alt="Encuéntrala en lacomer.com.mx" />
                    </a>
                </div>
                <div class="mRow-mobile-thee">
                    <a
                        href="https://www.heb.com.mx/tecate-cerveza-0-0-lata-355-ml-898460.html"
                        @click="retailerClick('Heb') & retailerGA('click', 'retailer :: heb', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="heb_mobile" alt="Encuéntrala en heb.com.mx" />
                    </a>
                    <a
                        href="https://super.walmart.com.mx/ip/bebida-no-alcoholica-tecate-cerveza-clara-0-0-alcohol-355-ml/00750303227243"
                        @click="retailerClick('Walmart') & retailerGA('click', 'retailer :: walmart', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="walmart_mobile" alt="Encuéntrala en Walmart.com.mx" />
                    </a>
                </div>
                <div class="mRow-mobile-four">
                    <a
                        href="https://www.amazon.com.mx/stores/page/AC57BA80-80DB-4887-A769-99E9E225DE06?ingress=0&visitId=f5a9b039-de01-4a75-a4ab-18a2d5222d5f"
                        @click="retailerClick('Amazon') & retailerGA('click', 'retailer :: amazon', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="amazon_mobile" alt="Encuéntrala en Amazon.com" />
                    </a>
                    <a
                        href="https://www.soriana.com/cerveza-tecate-0.0-lata-355-ml/11688516.html"
                        @click="retailerClick('Soriana') & retailerGA('click', 'retailer :: soriana', 'home')"
                        target="_blank"
                        :class="{animate: animate}"
                    >
                        <img :src="soriana_mobile" alt="Encuéntrala en soriana.com" />
                    </a>
                </div>
            </div>
        </div>
        <div class="mBanner-two">
            <div class="mLeft">
                <img class="mLSign" :src="sign" :class="{animate: animate, onlySafari: isSafari}" alt="NUEVA Tecate 0.0% alcohol">
                <img class="mLTitle" :src="title" :class="{animate: animate, onlySafari: isSafari}" alt="El sabor refrescante Nueva Cerveza Tecate 0.0, con todo el sabor refrescante, notas de malta y sutiles aromas frutales. Un amargo característico y una espuma solida que le imprime carácter para completar la experiencia de una cerveza completa">
                <div class="mLImage">
                    <img class="mLGlass" :src="glass" :class="{animate: animate}" alt="Vaso de cerveza dorado gracias a la malta que lleva en sus ingredientes">
                    <h2 class="mLsubtitle" :class="{animate: animate, onlySafari: isSafari}">Color <br/> dorado</h2>
                    <img class="mLCan-icon" :src="can_icon" :class="{animate: animate, onlySafari: isSafari}" alt="71KCAL">
                    <img class="mLBottle-icon" :src="bottle_icon" :class="{animate: animate, onlySafari: isSafari}" alt="74KCAL">
                </div>
            </div>
            <div class="mRight">
                <img class="mRCan" :src="can" :class="{animate: animate}" alt="Lata sleek 355ml">
                <h2 class="mRsubtitle-one" :class="{animate: animate, onlySafari: isSafari}">Lata sleek 355ml</h2>
                <img class="mRBottle" :src="bottle" :class="{animate: animate}" alt="Botella ret 325ml">
                <h3 class="mRsubtitle-two" :class="{animate: animate, onlySafari: isSafari}">Botella ret 325ml</h3>
            </div>
        </div>
    </div>
</template>

<script>
import walmart from "@/assets/retailers/WALMART.png";
import walmart_mobile from "@/assets/retailers/WALMART_MOBILE.png";
import amazon from "@/assets/retailers/AMAZON.png";
import amazon_mobile from "@/assets/retailers/AMAZON_MOBILE.png";
import glup from "@/assets/retailers/GLUP.png";
import glup_mobile from "@/assets/retailers/GLUP_MOBILE.png";
import cornershop from "@/assets/retailers/CORNERSHOP.png";
import cornershop_mobile from "@/assets/retailers/CORNERSHOP_MOBILE.png";
import mercado_libre from "@/assets/retailers/MERCADO_LIBRE.png";
import mercado_libre_mobile from "@/assets/retailers/MERCADOLIBRE_MOBILE.png";
import chedraui from "@/assets/retailers/CHEDRAUI.png";
import chedraui_mobile from "@/assets/retailers/CHEDRAUI_MOBILE.png";
import lacomer from "@/assets/retailers/LACOMER.png";
import lacomer_mobile from "@/assets/retailers/LACOMER_MOBILE.png";
import heb from "@/assets/retailers/HEB.png";
import heb_mobile from "@/assets/retailers/HEB_MOBILE.png";
import soriana from "@/assets/retailers/SORIANA.png";
import soriana_mobile from "@/assets/retailers/SORIANA_MOBILE.png";
import sign from "@/assets/beer/SIGN_TECATE.png";
import title from "@/assets/beer/TITLE.png";
import glass from "@/assets/beer/GLASS.png";
import can_icon from "@/assets/beer/CAN_ICONO.png";
import bottle_icon from "@/assets/beer/BOTTLE_ICONO.png";
import can from "@/assets/beer/CAN_TECATE.png";
import bottle from "@/assets/beer/BOTTLE_TECATE.png";
import { mapGetters } from "vuex";
import Bowser from "bowser";
import tagFunctions from '@/utils/tagFunctions.js'

export default {
    name: "Retailers",
    data() {
        return {
            walmart,
            walmart_mobile,
            amazon,
            amazon_mobile,
            glup,
            glup_mobile,
            cornershop,
            cornershop_mobile,
            mercado_libre,
            mercado_libre_mobile,
            chedraui,
            chedraui_mobile,
            lacomer,
            lacomer_mobile,
            heb,
            heb_mobile,
            soriana,
            soriana_mobile,
            sign,
            title,
            glass,
            can_icon,
            bottle_icon,
            can,
            bottle,
            animate: false,
            isSafari: false
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        },
        retailerClick(storeName) {
            tagFunctions.evib2cOutboundlinkPush(storeName)
        },
        retailerGA(action, element, section) {
            tagFunctions.user_interactionPush(action, element, section) 
        }
    },
    components: {},
    mounted() {
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Retailers.scss";
</style>